import { getAttributeValue, getProductImage, getUnitPriceCurrentItem } from '@/utils/productUtils';

const buildLinkedData = (url, product, itemJson, currency, ratingValue, ratingCount) => {
  const json = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    sku: product.partnumber,
    name: product.productName,
    image: getProductImage(product.image, false),
    url: `${url}/${product.isSpirit ? 'spirits/' : '' }${product.seoKeyword}`,
    description: product.longdesc,
    productionDate: getAttributeValue(product, 'millesime'),
    productID: product.partnumber,
    brand: {
      '@type': 'Thing',
      name: getAttributeValue(product, 'producteur')
    },
    manufacturer: {
      '@type': 'Organization',
      name: getAttributeValue(product, 'producteur')
    },
    offers: {
      '@type': 'Offer',
      priceCurrency: currency,
      price: getUnitPriceCurrentItem(itemJson, product),
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Thing',
        name: 'Millesima'
      }
    }
  };
  if (ratingValue && ratingValue !== '') {
    json.aggregateRating = {
      '@type': 'AggregateRating',
      bestRating: '5.00',
      ratingValue: ratingValue,
      ratingCount: ratingCount
    };
  }
  return json;
};

export default buildLinkedData;
